const tagTypeEnumItems = [{
    key: 11,
    name: "FilterAudience",
    pageTitle: "Filter: Audience"
  }, {
    key: 12,
    name: "FilterType",
    pageTitle: "Filter: Type"
  }, {
    key: 13,
    name: "FilterMode",
    pageTitle: "Filter: Mode"
  }, {
    key: 21,
    name: "ContentPedagogy",
    pageTitle: "Content: Pedagogy"
  }, {
    key: 22,
    name: "ContentTopic",
    pageTitle: "Content: Topic"
  }, {
    key: 23,
    name: "ContentSymptom",
    pageTitle: "Content: Symptom"
  }, {
    key: 24,
    name: "ContentIllness",
    pageTitle: "Content: Illness"
  }, {
    key: 25,
    name: "ContentContext",
    pageTitle: "Content: Context"
  }, {
    key: 26,
    name: "ContentRole",
    pageTitle: "Content: Role"
  }];

const resourceTypeEnumItems = [{
    key: 1,
    name: 'AudioVisual'
  }, {
    key: 2,
    name: 'CaseBased'
  }, {
    key: 3,
    name: 'CommunityOfPractice'
  }, {
    key: 4,
    name: 'Curriculum'
  }, {
    key: 5,
    name: 'LearningModule'
  }, {
    key: 6,
    name: 'LearningNeedsAnalysis'
  }, {
    key: 7,
    name: 'Placement'
  }, {
    key: 8,
    name: 'Toolkit'
  }, {
    key: 9,
    name: 'Workshop'
  }];

export {
  tagTypeEnumItems,
  resourceTypeEnumItems
}